import { React, useEffect } from "react";
import "./SobrePlataforma.scss";
import Ilustracao from "../../../assets/images/home/ilustracao.png";
import Aos from "aos";
import "aos/dist/aos.css";

const SobrePlataforma = () => {
  useEffect(() => {
    Aos.init({ duration: 2000 });
  }, []);

  return (
    <>
      <div className="view-sobre-plataforma">
        <div className="titulo">
          PLATAFORMA DESENVOLVIDA <br /> EXCLUSIVAMENTE PARA <br /> INTEGRADORES{" "}
          <br /> DE ENERGIA SOLAR
        </div>
        <div className="ilustracao">
          <img data-aos="fade-up" src={Ilustracao} alt="Ilustracao" />
        </div>
      </div>
    </>
  );
};

export default SobrePlataforma;
